export default __webpack_public_path__ + "static/media/logo.a55727e4.png";